// Email validation regex - RFC 5322 compliant
const EMAIL_REGEX = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;

/**
 * Validates a single email address
 * @param {string} email - Email address to validate
 * @returns {boolean} - True if valid, false otherwise
 */
export const validateEmail = (email) => {
  if (!email) return false;
  const trimmed = email.trim();
  return EMAIL_REGEX.test(trimmed);
};

/**
 * Validates an email field that may contain multiple emails
 * Handles both string and array formats (for tags mode)
 * Splits by common delimiters: comma, semicolon, newline, space
 * @param {string|array} value - Email field value
 * @returns {string|null} - Error message if invalid, null if valid
 */
export const validateEmailField = (value) => {
  if (!value) return null;

  // Handle both string and array formats (tags mode can return array)
  let emails = [];

  if (Array.isArray(value)) {
    emails = value;
  } else if (typeof value === 'string') {
    // Split by common delimiters: comma, semicolon, newline, space
    emails = value.split(/[,;\n\s]+/).map(e => e.trim()).filter(e => e);
  }

  // Validate each email
  const invalidEmails = emails.filter(email => !validateEmail(email));

  if (invalidEmails.length > 0) {
    return `Invalid email address(es): ${invalidEmails.join(', ')}`;
  }

  return null;
};

/**
 * Normalizes email input by splitting on common delimiters and trimming
 * Useful for cleaning pasted email lists
 * @param {string|array} value - Email field value
 * @returns {array} - Array of cleaned email addresses
 */
export const normalizeEmailField = (value) => {
  if (!value) return [];

  if (Array.isArray(value)) {
    return value.map(e => e.trim()).filter(e => e);
  }

  if (typeof value === 'string') {
    return value.split(/[,;\n\s]+/).map(e => e.trim()).filter(e => e);
  }

  return [];
};
